import React from 'react';
import {Box, Chip, CircularProgress, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {GREY, WHITE} from '../../../../BerendsohnMUITheme';
import {LlmCandidateState} from '../../../../store/models/DuplicateCheck';
import {LLM_PATTERN_LABELS, LLM_VERDICT_COLORS, LLM_VERDICT_LABELS} from './constants';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1),
        padding: theme.spacing(1, 1.5),
        borderLeft: `3px solid ${theme.palette.grey[400]}`,
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    chip: {
        color: WHITE,
        fontWeight: 'bold',
    },
    errorText: {
        color: theme.palette.error.main,
    },
    reasoning: {
        marginTop: theme.spacing(0.5),
        whiteSpace: 'pre-wrap',
    },
}));

export default function LlmAssessmentBox({result}: {result: LlmCandidateState}) {
    const classes = useStyles();

    if (result.state === 'loading') {
        return (
            <Box className={`${classes.root} ${classes.headerRow}`}>
                <CircularProgress size={16}/>
                <Typography variant="body2" color="textSecondary">LLM prüft…</Typography>
            </Box>
        );
    }
    if (result.state === 'error') {
        return (
            <Box className={classes.root}>
                <Typography variant="body2" className={classes.errorText}>{result.message}</Typography>
            </Box>
        );
    }
    if (result.state === 'missing') {
        return (
            <Box className={classes.root}>
                <Typography variant="body2" color="textSecondary">
                    Keine Bewertung für diesen Kandidaten erhalten
                </Typography>
            </Box>
        );
    }

    const {assessment, model} = result;
    return (
        <Box className={classes.root}>
            <Box className={classes.headerRow}>
                <Chip
                    label={LLM_VERDICT_LABELS[assessment.verdict] ?? assessment.verdict}
                    size="small"
                    className={classes.chip}
                    style={{
                        backgroundColor: LLM_VERDICT_COLORS[assessment.verdict] ?? GREY,
                        color: assessment.verdict === 'uncertain' ? 'rgba(0,0,0,0.87)' : undefined,
                    }}
                />
                {assessment.pattern && (
                    <Chip label={LLM_PATTERN_LABELS[assessment.pattern] ?? assessment.pattern} size="small" variant="outlined"/>
                )}
                <Typography variant="body2">
                    Konfidenz <b>{Math.round(assessment.confidence * 100)} %</b>
                </Typography>
                <Typography variant="caption" color="textSecondary">{model}</Typography>
            </Box>
            <Typography variant="body2" className={classes.reasoning}>{assessment.reasoning}</Typography>
        </Box>
    );
}
